import {FormChooseExternal} from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemAoName, FormItemAoNo} from '../AO/FormChooseAo.jsx'

export default function FormChooseAo(props) {
    return (
        <FormChooseExternal {...props}>
            <FormItemAoNo />
            <FormItemAoName />
        </FormChooseExternal>
    )
}
